/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react'
import StepUploadFile from "../../../components/Wizard/Steps/StepUploadFile";
import {errorMessagesTitle, fileProcessingMessagesTitle} from "../../radar/SensorRadar/constants";
import Step2DTracesTop from "./Step2DTracesTop";
import Step2DTracesFront from "./Step2DTracesFront";
import Step2DTracesSide from "./Step2DTracesSide";
import Step3D from "./Step3D";
import {WizardDialog} from "../../../components/Wizard/WizardDialog";
import {config} from "../../../../AppConfig/config";
import {InstructionsStep} from '../../../components/Wizard/Steps/InstructionsStep';

const uploadFileUrl = `${config.url.API_URL}/HttpTriggerUploadVehicleProgram`

function VehicleProgramWizard(props: any) {
  return (
    <div>
      <WizardDialog headerTitle={'Import Vehicle Program Wizard'} fullScreen={false} height={'90vh'}>
        <StepUploadFile uploadFileUrl={uploadFileUrl} messagesTitle={fileProcessingMessagesTitle}/>
        <InstructionsStep indexForErrorMessages={0} indexForWarningMessages={0} type={'general_info'} messagesTitle={errorMessagesTitle}/>
        <InstructionsStep indexForErrorMessages={1} indexForWarningMessages={1} type={'performance'} messagesTitle={errorMessagesTitle}/>
        <Step2DTracesTop messagesTitle={errorMessagesTitle}/>
        <Step2DTracesFront messagesTitle={errorMessagesTitle}/>
        <Step2DTracesSide messagesTitle={errorMessagesTitle}/>
        <Step3D messagesTitle={errorMessagesTitle} id={props?.id} versionNumber={props?.versionNumber} programCode={props?.programCode}/>
      </WizardDialog>
    </div>
  )
}

export default VehicleProgramWizard;